import { Box, Button, Flex, Heading } from "monday-ui-react-core";
import type { Dispatch, SetStateAction } from "react";
import styled from "styled-components";

import { CloneItemList } from "@/components/BacklogTable/CloneItemList";
import { clonePlusDialog } from "@/lib/monday";
import type { Item } from "@/types/common";

import iconOne from "../../../../assets/icons/group-705.svg";

interface Props {
  boardId: number;
  setBoardId: Dispatch<SetStateAction<number>>;
  items: Item[];
  selectedItems: string[];
  setSelectedItems: Dispatch<SetStateAction<string[]>>;
  setCloneItems: Dispatch<SetStateAction<string[]>>;
  loading?: boolean;
}

const CloneItemsWrapper = styled.div`
  box-sizing: border-box;
  padding-top: 15px;
  padding-left: var(--spacing-medium);
  padding-right: var(--spacing-medium);
  width: 100%;
`;

export function CloneItems({
  boardId,
  setBoardId,
  items,
  selectedItems,
  setSelectedItems,
  setCloneItems,
  loading = false,
}: Props) {
  const show = items.length > 0;
  const width = "98vw";
  const height = "98vh";

  const onAddClose = (data: { dataJson?: string } = {}) => {
    if (data.dataJson) {
      const { boardId, selectedItems } = JSON.parse(data.dataJson) as {
        boardId: number;
        selectedItems: string[];
      };
      setBoardId(selectedItems.length > 0 ? boardId : -1);
      setSelectedItems(selectedItems);
      setCloneItems(selectedItems);
    }
  };

  return (
    <CloneItemsWrapper>
      <Box
        border={Box.borders.DEFAULT}
        rounded={Box.roundeds.SMALL}
        paddingX={Box.paddingXs.SMALL}
        paddingY={Box.paddingYs.SMALL}
      >
        <Flex
          direction={Flex.directions.COLUMN}
          align={Flex.align.START}
          gap={Flex.gaps.SMALL}
          style={{ marginBottom: "5px", padding: "8px" }}
        >
          <Flex direction={Flex.directions.ROW} style={{ height: "30px" }}>
            <img src={iconOne} alt="restricted access" />
            <Heading type={Heading.types.h5} value="Clone items" />
          </Flex>
          {show && <CloneItemList items={items} selectedItems={selectedItems} setSelectedItems={setSelectedItems} />}
          <Button
            kind={Button.kinds.PRIMARY}
            onClick={() =>
              void clonePlusDialog.showModalDialog(
                { dataJson: JSON.stringify({ boardId, selectedItems }) },
                "/selectItems",
                width,
                height,
                onAddClose
              )
            }
            disabled={loading}
          >
            + Select board, group, or item...
          </Button>
        </Flex>
      </Box>
    </CloneItemsWrapper>
  );
}
